export enum PccDischargeReviewReason {
  NoMatchingDisposition = 'no_matching_disposition',
  ReferralDidNotFit = 'referral_did_not_fit',
}

export type PccDischargeDetails = {
  statusCode?: string;
  statusDisplay?: string;
  statusText?: string;
  dischargedAt?: string;
  destination?: string;
  destinationType?: string;
};

export interface PccDischargeReportOptions {
  id: string;
  locationEpisodeId: string;
  locationEpisodeDischargeId: string | null;
  reviewReason: PccDischargeReviewReason | null;
  details: PccDischargeDetails;
  createdAt: string | null;
}

function getDefaults(): PccDischargeReportOptions {
  return {
    id: '',
    locationEpisodeId: '',
    locationEpisodeDischargeId: null,
    reviewReason: null,
    details: {},
    createdAt: null,
  };
}

export default class PccDischargeReport {
  id: string;
  locationEpisodeId: string;
  locationEpisodeDischargeId: string | null;
  reviewReason: PccDischargeReviewReason | null;
  details: PccDischargeDetails;
  createdAt: string | null;

  constructor(options: Partial<PccDischargeReportOptions> = {}) {
    const opts = { ...getDefaults(), ...options };
    this.id = opts.id;
    this.locationEpisodeId = opts.locationEpisodeId;
    this.locationEpisodeDischargeId = opts.locationEpisodeDischargeId;
    this.reviewReason = opts.reviewReason;
    this.details = opts.details ?? {};
    this.createdAt = opts.createdAt;
  }

  // Edits to a discharge save a new discharge record, so the report only points at the one Olio made
  filledIn(dischargeId: string) {
    return this.locationEpisodeDischargeId === dischargeId;
  }
}
